import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class MenuEndpoint extends BaseEndpoint {}
